export default "__VITE_ASSET__BnOMcbqg__ 720w";